import { Component, Input, forwardRef } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseControl } from '../../ui/controls/base-control.model';
import { NumericControl } from '../../ui/controls/numeric-control.model';
import { SelectControl } from '../../ui/controls/select-control.model';
import { OnChangeArgs, SelectFieldComponent } from '../select-field/select-field.component';
import { UrlFieldComponent } from '../url-field/url-field.component';
import { MoneyFieldComponent } from '../money-field/money-field.component';
import { CheckBoxModule, NumericTextBoxModule, TextAreaModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { CardModule } from '@progress/kendo-angular-layout';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LabelModule } from '@progress/kendo-angular-label';
import { TranslateModule } from '@ngx-translate/core';
import { LabelSettings, ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { UploadImageComponent } from '../upload-image/upload-image.component';
import { GridKendoCardComponent } from '../grid-kendo-card/grid-kendo-card.component';
import { PasswordComponent } from '../password/password.component';
import { EditorModule } from '@progress/kendo-angular-editor';
//import { MeasurementUnitFieldComponent } from '../measurement-unit-field/measurement-unit-field.component';
//import { BaseControlIsRequiredPipe } from '../../pipes/base-control-isrequired.pipe';
//import { UiGroupControlPropertyGetterPipe } from '../../pipes/group-control-prop-getter.pipe';
//import { NumericControlPropertyGetterPipe } from '../../pipes/numeric-control-prop-getter.pipe';
//import { FormControlSimpleComponent } from '../form-control-simple/form-control-simple.component';


@Component({
    selector: 'app-form-control',
    imports: [
        forwardRef(() => SelectFieldComponent),
        UrlFieldComponent,
        MoneyFieldComponent,
        TextBoxModule,
        TextAreaModule,
        EditorModule,
        DatePickerModule,
        CardModule,
        IndicatorsModule,
        UploadImageComponent,
        GridKendoCardComponent,
        ProgressBarModule,
        NumericTextBoxModule,
        ReactiveFormsModule,
        PasswordComponent,
        LabelModule,
        TranslateModule,
        CheckBoxModule
    ],
    templateUrl: './form-control.component.html',
    styleUrls: ['./form-control.component.css']
})
export class FormControlComponent {

  @Input() control: BaseControl;
  @Input() form: FormGroup;
  @Input() submitted: boolean;

  constructor() { }

  toNumeric(control: BaseControl): NumericControl {
    return control as NumericControl;
  }

  onSelectChange(control: BaseControl, args: OnChangeArgs): void {
    var select = control as SelectControl;
    if (select.onchange != undefined) {
      select.onchange(args);
    }
  }

  getIsRequired(control: BaseControl): string {
    if (control && control.isRequired) {
      return "*";
    }
    return "";
  }

  getFormattedId(control: BaseControl): string {
    if (control instanceof SelectControl) {
      var s = control as SelectControl;
      if (s.postAsDisplayName) {
        var idTrim = s.id.substring(0, s.id.length - 2);
        return idTrim + "_Name";
      } else {
        return control.id;
      }
    } else {
      return control.id;
    }

  }

}
